import { render, staticRenderFns } from "./Scroll-Loader.vue?vue&type=template&id=6973bf91&scoped=true&lang=html"
import script from "./Scroll-Loader.vue?vue&type=script&lang=js"
export * from "./Scroll-Loader.vue?vue&type=script&lang=js"
import style0 from "./Scroll-Loader.vue?vue&type=style&index=0&id=6973bf91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973bf91",
  null
  
)

export default component.exports